/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Type\CarElement.type.hold.ts
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Thursday June 8th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Monday, 27th November 2023 04:40:48
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import Config from "Config/Config";

class CarCost {
  public carCost = 0;

  public fromJson(jsonObj: any) {
    this.carCost = parseInt(jsonObj.SellPrice);
  }
}

class IconSubSection {
  IconSubSection = "";

  public fromJson(jsonObj: any) {
    this.IconSubSection = jsonObj.SubSection;
  }
}

class CarInfo {
  public Status = "";
  public Brand = "";
  public Model = "";
  public Version = "";
  public Mileage = 0;
  public CirculationDate: Date = new Date();
  public Gears = "";
  public Energy = "";
  public SellPrice = 0;
  public Color = "";
  public StoragePlace: {
    Address: string;
    City: string;
    Country: string;
    Name: string;
    PostalCode: number;
    State: string;
    id: number;
  } = {
    Address: "",
    City: "",
    Country: "",
    Name: "",
    PostalCode: 0,
    State: "",
    id: 0,
  };
  public CarType: {
    Abreviation: string;
    Name: string;
    id: number;
  } = {
    Abreviation: "",
    Name: "",
    id: 0,
  };

  public fromJson(jsonObj: any) {
    this.Status = jsonObj.Status;
    this.Brand = jsonObj.Brand;
    this.Model = jsonObj.Model;
    this.Version = jsonObj.Version;
    this.Mileage = parseInt(jsonObj.Mileage);
    this.CirculationDate = new Date(jsonObj.CirculationDate);
    this.Gears = jsonObj.Gears;
    this.SellPrice = jsonObj.SellPrice;
    this.Color = jsonObj.Color;
    this.Energy = jsonObj.Energy;
    this.StoragePlace = jsonObj.StoragePlace;
    this.CarType = jsonObj.CarType;
  }
}

class CarImg {
  public url: string =
    Config.BACKEND.BASEURL + Config.BACKEND.PATHS.GET_PICTURE;
  public status = "";
  public subSection = "";

  public fromJson(jsonObj: any) {
    this.url =
      Config.BACKEND.BASEURL +
      Config.BACKEND.PATHS.GET_PICTURE +
      `${jsonObj.id}`;
    this.status = jsonObj.Status;
    this.subSection = jsonObj.SubSection;
  }
}

export type UpdateCarInfo = {
  RegNb?: string
  VIN?: string
  Brand?: string
  Model?: string
  Version?: string
  Color?: string
  Energy?: string
  Mileage?: number
  VAT?: boolean
  CirculationDate?: Date | string
  Status?: string
  Gears?: string | null
  CustomText?: string
  Comments?: string | null
  SellPrice?: number | null
  SubSection?: string
  Cost?: number | null
  StartPrice?: number | null
  MinAutobuyPrice?: number | null
  Doors?: number | null
  Seats?: number | null
  Report1?: string
  Report2?: string
  Maintenance?: string
  isPromo?: boolean
  TypeID?: string
  CP?: number
  CK?: number
}

export type UpdatePictureInfo = {
  id: string,
  Index: number
}

export type EquipmentsToUpdate = {
  id?: string,
  Name: string,
  Optionnal?: boolean
}

export type UpdateCarType = {
  create: {
    EquipmentsToCreate?: EquipmentsToUpdate[],
    PictureToCreate?: string[]
  },
  update: {
    EquipmentsToUpdate?: EquipmentsToUpdate[],
    pictureData?: UpdatePictureInfo[],
    carData?: UpdateCarInfo & {[valName: string]: string | undefined},
    updated: boolean
  },
  delete: {
    EquipmentsToDelete?: string[],
    PictureToDelete?: string[]
  }
}

export type UpdateCarInfoKey = keyof UpdateCarInfo

export class SingleCarFormat {
  public id = 0;
  public carCost: CarCost = new CarCost();
  public carInfo: CarInfo = new CarInfo();
  public iconSubSection: IconSubSection = new IconSubSection();
  public carImg: CarImg = new CarImg();

  public fromJson(jsonObj: any): void {
    this.id = jsonObj.id;
    this.carCost.fromJson(jsonObj);
    this.iconSubSection.fromJson(jsonObj);
    this.carInfo.fromJson(jsonObj);
    this.carImg.fromJson(jsonObj);
  }
}

type Park = {
  id: string,
  Address: string,
  Name: string,
  PostalCode: number,
  City: string
}

export type CarInSell = {
  id: string;
  RegNb: string;
  Brand: string;
  Model: string;
  Version: string;
  StoragePlace: Park;
  ParkID: string;
  Status: string;
  Views: number;
  CarPicture: {
    Index: number,
    Pict: {
      id: string,
      Name: string,
      Path: string,
      URI: string
    }
  }[];
  Mileage: number;
  CirculationDate: Date;
  Offers: any[];
  SeenCars: any[];
}
